export const allocationResources = {
  fr: {
    card: {
      warehouse: "Entrepôt",
      client: "Propriétaire du stock",
      item: "Article",
      description: "Désignation",
      requested: "Quantité demandée",
      huCount: "Nombre de HU",
      rotation: "Règle de rotation",
      sequence: "Séquence",
      hu: "Unité logistique (HU)",
      allocated: "Quantité allouée",
      location: "Emplacement",
      lot: "Lot",
      expiration: "Date de péremption",
      created: "Date de création",
      expires: "Expiration de la réservation",
      createdBy: "Créée par"
    },
    module: "Allocations", title: "Allocations de stock", searchPlaceholder: "Référence, article, entrepôt, propriétaire, HU ou lot…",
    tabs: { open: "Ouvertes", closed: "Clôturées" },
    tabsMobile: { open: "OUVERTES", closed: "CLÔTURÉES" },
    filters: {
      syntaxPlaceholder: "article:MAT0001 statut:OPEN lot:LOT01",
      syntaxHelp: "Syntaxe : id:, article:, entrepot:, client:, strategie:, statut:, hu:, lot:, date:."
    },
    actions: {
      new: "Nouvelle allocation", newShort: "Nouvelle", release: "Libérer",
      releaseAllocation: "Libérer l’allocation", prepare: "Préparer", select: "Sélectionner",
      closed: "Allocation clôturée", correct: "Corriger", simulate: "Simuler",
      reserve: "Réserver", releaseReservation: "Libérer la réservation"
    },
    labels: {
      ownStock: "Stock propre", stockAllocation: "Allocation de stock",
      createdExpires: "Créée le {{created}} · expire le {{expires}} · {{user}}",
      unknownUser: "Utilisateur inconnu", huCount: "{{count}} HU", lot: "lot {{lot}}",
      reason: "Motif : {{reason}}", newDialog: "Nouvelle allocation de stock",
      itemUom: "Article / UOM", warehouseOwner: "Entrepôt / propriétaire",
      itemAvailable: "disponible article {{quantity}} {{uom}}", quantity: "Quantité",
      reservationDuration: "Durée de réservation (minutes)", requestReference: "Référence de demande",
      complete: "Allocation complète", insufficient: "Stock éligible insuffisant",
      excludedStock: "Stock écarté de la simulation", expiration: "péremption {{date}}",
      minimumShelfLife: "Durée de vie restante minimale : {{days}} jours",
      releaseDialog: "Libérer {{reference}}", reasonField: "Motif"
    },
    help: {
      reservationReadonly: "Lecture seule — Configuration > Écran Allocations",
      optionalReference: "Facultative ; une référence sera générée si vide.",
      requiredThree: "Obligatoire — minimum 3 caractères",
      releaseWarning: "Le stock réservé redeviendra immédiatement disponible pour une autre allocation."
    },
    simulationChecks: {
      PARTIAL_HU_ALLOWED: "HU partielle autorisée", PARTIAL_HU_FORBIDDEN: "HU partielle interdite",
      LOT_MIXING_ALLOWED: "Mélange de lots autorisé", LOT_MIXING_FORBIDDEN: "Mélange de lots interdit",
      AUTOMATIC_ALLOCATION_DISABLED: "Allocation automatique désactivée",
      QUANTITY_FULLY_ALLOCATED: "Quantité entièrement allouée",
      QUANTITY_PARTIALLY_ALLOCATED: "Quantité partiellement allouée"
    },
    exclusions: {
      EXPIRED: "lot périmé",
      INSUFFICIENT_REMAINING_SHELF_LIFE: "durée restante inférieure au minimum exigé de {{days}} jours"
    },
    empty: { list: "Aucune allocation dans cette liste." },
    errors: {
      load: "Impossible de charger les allocations.", simulation: "Simulation impossible.",
      reserve: "Réservation impossible.", release: "Libération impossible."
    }
  },
  en: {
    card: {
      warehouse: "Warehouse",
      client: "Stock owner",
      item: "Material",
      description: "Description",
      requested: "Requested quantity",
      huCount: "Number of HUs",
      rotation: "Rotation rule",
      sequence: "Sequence",
      hu: "Handling unit (HU)",
      allocated: "Allocated quantity",
      location: "Location",
      lot: "Lot",
      expiration: "Expiry date",
      created: "Creation date",
      expires: "Reservation expiry",
      createdBy: "Created by"
    },
    module: "Allocations", title: "Stock allocations", searchPlaceholder: "Reference, material, warehouse, owner, HU or lot…",
    tabs: { open: "Open", closed: "Closed" },
    tabsMobile: { open: "OPEN", closed: "CLOSED" },
    filters: {
      syntaxPlaceholder: "item:MAT0001 status:OPEN lot:LOT01",
      syntaxHelp: "Syntax: id:, item:, warehouse:, client:, strategy:, status:, hu:, lot:, date:."
    },
    actions: {
      new: "New allocation", newShort: "New", release: "Release",
      releaseAllocation: "Release allocation", prepare: "Prepare", select: "Select",
      closed: "Allocation closed", correct: "Edit", simulate: "Simulate",
      reserve: "Reserve", releaseReservation: "Release reservation"
    },
    labels: {
      ownStock: "Own stock", stockAllocation: "Stock allocation",
      createdExpires: "Created on {{created}} · expires on {{expires}} · {{user}}",
      unknownUser: "Unknown user", huCount: "{{count}} HU", lot: "lot {{lot}}",
      reason: "Reason: {{reason}}", newDialog: "New stock allocation",
      itemUom: "Material / UOM", warehouseOwner: "Warehouse / owner",
      itemAvailable: "material available {{quantity}} {{uom}}", quantity: "Quantity",
      reservationDuration: "Reservation duration (minutes)", requestReference: "Request reference",
      complete: "Full allocation", insufficient: "Insufficient eligible stock",
      excludedStock: "Stock excluded from simulation", expiration: "expiry {{date}}",
      minimumShelfLife: "Minimum remaining shelf life: {{days}} days",
      releaseDialog: "Release {{reference}}", reasonField: "Reason"
    },
    help: {
      reservationReadonly: "Read only — Configuration > Allocations screen",
      optionalReference: "Optional; a reference will be generated if left empty.",
      requiredThree: "Required — at least 3 characters",
      releaseWarning: "Reserved stock will immediately become available to another allocation."
    },
    simulationChecks: {
      PARTIAL_HU_ALLOWED: "Partial HU allowed", PARTIAL_HU_FORBIDDEN: "Partial HU forbidden",
      LOT_MIXING_ALLOWED: "Lot mixing allowed", LOT_MIXING_FORBIDDEN: "Lot mixing forbidden",
      AUTOMATIC_ALLOCATION_DISABLED: "Automatic allocation disabled",
      QUANTITY_FULLY_ALLOCATED: "Quantity fully allocated",
      QUANTITY_PARTIALLY_ALLOCATED: "Quantity partially allocated"
    },
    exclusions: {
      EXPIRED: "expired lot",
      INSUFFICIENT_REMAINING_SHELF_LIFE: "remaining shelf life below the required minimum of {{days}} days"
    },
    empty: { list: "No allocation in this list." },
    errors: {
      load: "Unable to load allocations.", simulation: "Unable to run simulation.",
      reserve: "Unable to reserve stock.", release: "Unable to release allocation."
    }
  }
} as const;
